import './App.css';
import React from "react";
import ClientForm from "./components/ClientForm";
import CancellationForm from "./components/CancellationForm";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
      <div className="App">
        <Routes>
          <Route path="/" element={<ClientForm />} />
          <Route path="/cancel" element={<CancellationForm />} />
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </div>
  );
}

export default App;
